import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './ui-layout-bar.css?inline';

const CName = 'ui-layout-bar';

@customElement(CName)
export class UIBar extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: String }) class?: string;

  render() {
    return html`
      <div class="top-wrapper ${this.class}">
        <slot name="top"></slot>
      </div>
      <div class="main-wrapper ${this.class}">
        <slot name="left"></slot>
        <slot name="center"></slot>
        <slot name="right"></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIBar;
  }
}
